// @generated by protobuf-ts 2.11.1 with parameter output_javascript
// @generated from protobuf file "stripe.proto" (syntax proto3)
// tslint:disable
// @generated by protobuf-ts 2.11.1 with parameter output_javascript
// @generated from protobuf file "stripe.proto" (syntax proto3)
// tslint:disable
import { String$ } from "./common";
import { Empty } from "./common";
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { WireType } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
// @generated message type with reflection information, may provide speed optimized methods
class StripeCustomer$Type extends MessageType {
    constructor() {
        super("StripeCustomer", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "email", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "metadata", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ } },
            { no: 6, name: "default_payment_method", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "created", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 8, name: "user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.email = "";
        message.name = "";
        message.description = "";
        message.metadata = {};
        message.defaultPaymentMethod = "";
        message.created = 0n;
        message.userId = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string email */ 2:
                    message.email = reader.string();
                    break;
                case /* string name */ 3:
                    message.name = reader.string();
                    break;
                case /* string description */ 4:
                    message.description = reader.string();
                    break;
                case /* map<string, string> metadata */ 5:
                    this.binaryReadMap5(message.metadata, reader, options);
                    break;
                case /* string default_payment_method */ 6:
                    message.defaultPaymentMethod = reader.string();
                    break;
                case /* int64 created */ 7:
                    message.created = reader.int64().toBigInt();
                    break;
                case /* int32 user_id */ 8:
                    message.userId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    binaryReadMap5(map, reader, options) {
        let len = reader.uint32(), end = reader.pos + len, key, val;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for StripeCustomer.metadata");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string email = 2; */
        if (message.email !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.email);
        /* string name = 3; */
        if (message.name !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.name);
        /* string description = 4; */
        if (message.description !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.description);
        /* map<string, string> metadata = 5; */
        for (let k of globalThis.Object.keys(message.metadata))
            writer.tag(5, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.metadata[k]).join();
        /* string default_payment_method = 6; */
        if (message.defaultPaymentMethod !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.defaultPaymentMethod);
        /* int64 created = 7; */
        if (message.created !== 0n)
            writer.tag(7, WireType.Varint).int64(message.created);
        /* int32 user_id = 8; */
        if (message.userId !== 0)
            writer.tag(8, WireType.Varint).int32(message.userId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message StripeCustomer
 */
export const StripeCustomer = new StripeCustomer$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PaymentMethod$Type extends MessageType {
    constructor() {
        super("PaymentMethod", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "customer_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "card", kind: "message", T: () => PaymentMethod_Card }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.type = "";
        message.customerId = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string type */ 2:
                    message.type = reader.string();
                    break;
                case /* string customer_id */ 3:
                    message.customerId = reader.string();
                    break;
                case /* PaymentMethod.Card card */ 4:
                    message.card = PaymentMethod_Card.internalBinaryRead(reader, reader.uint32(), options, message.card);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string type = 2; */
        if (message.type !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.type);
        /* string customer_id = 3; */
        if (message.customerId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.customerId);
        /* PaymentMethod.Card card = 4; */
        if (message.card)
            PaymentMethod_Card.internalBinaryWrite(message.card, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message PaymentMethod
 */
export const PaymentMethod = new PaymentMethod$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PaymentMethod_Card$Type extends MessageType {
    constructor() {
        super("PaymentMethod.Card", [
            { no: 1, name: "brand", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "last4", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "exp_month", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "exp_year", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.brand = "";
        message.last4 = "";
        message.expMonth = 0;
        message.expYear = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string brand */ 1:
                    message.brand = reader.string();
                    break;
                case /* string last4 */ 2:
                    message.last4 = reader.string();
                    break;
                case /* int32 exp_month */ 3:
                    message.expMonth = reader.int32();
                    break;
                case /* int32 exp_year */ 4:
                    message.expYear = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string brand = 1; */
        if (message.brand !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.brand);
        /* string last4 = 2; */
        if (message.last4 !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.last4);
        /* int32 exp_month = 3; */
        if (message.expMonth !== 0)
            writer.tag(3, WireType.Varint).int32(message.expMonth);
        /* int32 exp_year = 4; */
        if (message.expYear !== 0)
            writer.tag(4, WireType.Varint).int32(message.expYear);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message PaymentMethod.Card
 */
export const PaymentMethod_Card = new PaymentMethod_Card$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StripeProduct$Type extends MessageType {
    constructor() {
        super("StripeProduct", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "metadata", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ } }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.name = "";
        message.description = "";
        message.active = false;
        message.metadata = {};
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* string description */ 3:
                    message.description = reader.string();
                    break;
                case /* bool active */ 4:
                    message.active = reader.bool();
                    break;
                case /* map<string, string> metadata */ 5:
                    this.binaryReadMap5(message.metadata, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    binaryReadMap5(map, reader, options) {
        let len = reader.uint32(), end = reader.pos + len, key, val;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for StripeProduct.metadata");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* string description = 3; */
        if (message.description !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.description);
        /* bool active = 4; */
        if (message.active !== false)
            writer.tag(4, WireType.Varint).bool(message.active);
        /* map<string, string> metadata = 5; */
        for (let k of globalThis.Object.keys(message.metadata))
            writer.tag(5, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.metadata[k]).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message StripeProduct
 */
export const StripeProduct = new StripeProduct$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Price$Type extends MessageType {
    constructor() {
        super("Price", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "product_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "currency", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "unit_amount", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 5, name: "recurring", kind: "message", T: () => Price_Recurring },
            { no: 6, name: "active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.productId = "";
        message.currency = "";
        message.unitAmount = 0n;
        message.active = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string product_id */ 2:
                    message.productId = reader.string();
                    break;
                case /* string currency */ 3:
                    message.currency = reader.string();
                    break;
                case /* int64 unit_amount */ 4:
                    message.unitAmount = reader.int64().toBigInt();
                    break;
                case /* Price.Recurring recurring */ 5:
                    message.recurring = Price_Recurring.internalBinaryRead(reader, reader.uint32(), options, message.recurring);
                    break;
                case /* bool active */ 6:
                    message.active = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string product_id = 2; */
        if (message.productId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.productId);
        /* string currency = 3; */
        if (message.currency !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.currency);
        /* int64 unit_amount = 4; */
        if (message.unitAmount !== 0n)
            writer.tag(4, WireType.Varint).int64(message.unitAmount);
        /* Price.Recurring recurring = 5; */
        if (message.recurring)
            Price_Recurring.internalBinaryWrite(message.recurring, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* bool active = 6; */
        if (message.active !== false)
            writer.tag(6, WireType.Varint).bool(message.active);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message Price
 */
export const Price = new Price$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Price_Recurring$Type extends MessageType {
    constructor() {
        super("Price.Recurring", [
            { no: 1, name: "interval", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "interval_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "usage_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.interval = "";
        message.intervalCount = 0;
        message.usageType = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string interval */ 1:
                    message.interval = reader.string();
                    break;
                case /* int32 interval_count */ 2:
                    message.intervalCount = reader.int32();
                    break;
                case /* string usage_type */ 3:
                    message.usageType = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string interval = 1; */
        if (message.interval !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.interval);
        /* int32 interval_count = 2; */
        if (message.intervalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.intervalCount);
        /* string usage_type = 3; */
        if (message.usageType !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.usageType);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message Price.Recurring
 */
export const Price_Recurring = new Price_Recurring$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Subscription$Type extends MessageType {
    constructor() {
        super("Subscription", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "customer_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "current_period_start", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 5, name: "current_period_end", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 6, name: "cancel_at_period_end", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "items", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Subscription_Item },
            { no: 8, name: "created", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 9, name: "metadata", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ } },
            { no: 10, name: "user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.customerId = "";
        message.status = "";
        message.currentPeriodStart = 0n;
        message.currentPeriodEnd = 0n;
        message.cancelAtPeriodEnd = false;
        message.items = [];
        message.created = 0n;
        message.metadata = {};
        message.userId = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string customer_id */ 2:
                    message.customerId = reader.string();
                    break;
                case /* string status */ 3:
                    message.status = reader.string();
                    break;
                case /* int64 current_period_start */ 4:
                    message.currentPeriodStart = reader.int64().toBigInt();
                    break;
                case /* int64 current_period_end */ 5:
                    message.currentPeriodEnd = reader.int64().toBigInt();
                    break;
                case /* bool cancel_at_period_end */ 6:
                    message.cancelAtPeriodEnd = reader.bool();
                    break;
                case /* repeated Subscription.Item items */ 7:
                    message.items.push(Subscription_Item.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int64 created */ 8:
                    message.created = reader.int64().toBigInt();
                    break;
                case /* map<string, string> metadata */ 9:
                    this.binaryReadMap9(message.metadata, reader, options);
                    break;
                case /* int32 user_id */ 10:
                    message.userId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    binaryReadMap9(map, reader, options) {
        let len = reader.uint32(), end = reader.pos + len, key, val;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for Subscription.metadata");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string customer_id = 2; */
        if (message.customerId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.customerId);
        /* string status = 3; */
        if (message.status !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.status);
        /* int64 current_period_start = 4; */
        if (message.currentPeriodStart !== 0n)
            writer.tag(4, WireType.Varint).int64(message.currentPeriodStart);
        /* int64 current_period_end = 5; */
        if (message.currentPeriodEnd !== 0n)
            writer.tag(5, WireType.Varint).int64(message.currentPeriodEnd);
        /* bool cancel_at_period_end = 6; */
        if (message.cancelAtPeriodEnd !== false)
            writer.tag(6, WireType.Varint).bool(message.cancelAtPeriodEnd);
        /* repeated Subscription.Item items = 7; */
        for (let i = 0; i < message.items.length; i++)
            Subscription_Item.internalBinaryWrite(message.items[i], writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* int64 created = 8; */
        if (message.created !== 0n)
            writer.tag(8, WireType.Varint).int64(message.created);
        /* map<string, string> metadata = 9; */
        for (let k of globalThis.Object.keys(message.metadata))
            writer.tag(9, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.metadata[k]).join();
        /* int32 user_id = 10; */
        if (message.userId !== 0)
            writer.tag(10, WireType.Varint).int32(message.userId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message Subscription
 */
export const Subscription = new Subscription$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Subscription_Item$Type extends MessageType {
    constructor() {
        super("Subscription.Item", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "price_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "quantity", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.priceId = "";
        message.quantity = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string price_id */ 2:
                    message.priceId = reader.string();
                    break;
                case /* int32 quantity */ 3:
                    message.quantity = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string price_id = 2; */
        if (message.priceId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.priceId);
        /* int32 quantity = 3; */
        if (message.quantity !== 0)
            writer.tag(3, WireType.Varint).int32(message.quantity);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message Subscription.Item
 */
export const Subscription_Item = new Subscription_Item$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StripeInvoice$Type extends MessageType {
    constructor() {
        super("StripeInvoice", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "customer_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "subscription_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "amount_due", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 6, name: "amount_paid", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 7, name: "created", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 8, name: "due_date", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 9, name: "user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.customerId = "";
        message.subscriptionId = "";
        message.status = "";
        message.amountDue = 0n;
        message.amountPaid = 0n;
        message.created = 0n;
        message.dueDate = 0n;
        message.userId = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string customer_id */ 2:
                    message.customerId = reader.string();
                    break;
                case /* string subscription_id */ 3:
                    message.subscriptionId = reader.string();
                    break;
                case /* string status */ 4:
                    message.status = reader.string();
                    break;
                case /* int64 amount_due */ 5:
                    message.amountDue = reader.int64().toBigInt();
                    break;
                case /* int64 amount_paid */ 6:
                    message.amountPaid = reader.int64().toBigInt();
                    break;
                case /* int64 created */ 7:
                    message.created = reader.int64().toBigInt();
                    break;
                case /* int64 due_date */ 8:
                    message.dueDate = reader.int64().toBigInt();
                    break;
                case /* int32 user_id */ 9:
                    message.userId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string customer_id = 2; */
        if (message.customerId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.customerId);
        /* string subscription_id = 3; */
        if (message.subscriptionId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.subscriptionId);
        /* string status = 4; */
        if (message.status !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.status);
        /* int64 amount_due = 5; */
        if (message.amountDue !== 0n)
            writer.tag(5, WireType.Varint).int64(message.amountDue);
        /* int64 amount_paid = 6; */
        if (message.amountPaid !== 0n)
            writer.tag(6, WireType.Varint).int64(message.amountPaid);
        /* int64 created = 7; */
        if (message.created !== 0n)
            writer.tag(7, WireType.Varint).int64(message.created);
        /* int64 due_date = 8; */
        if (message.dueDate !== 0n)
            writer.tag(8, WireType.Varint).int64(message.dueDate);
        /* int32 user_id = 9; */
        if (message.userId !== 0)
            writer.tag(9, WireType.Varint).int32(message.userId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message StripeInvoice
 */
export const StripeInvoice = new StripeInvoice$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StripeEvent$Type extends MessageType {
    constructor() {
        super("StripeEvent", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "api_version", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "created", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 5, name: "object_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "object_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "data_json", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.type = "";
        message.apiVersion = "";
        message.created = 0n;
        message.objectId = "";
        message.objectType = "";
        message.dataJson = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string type */ 2:
                    message.type = reader.string();
                    break;
                case /* string api_version */ 3:
                    message.apiVersion = reader.string();
                    break;
                case /* int64 created */ 4:
                    message.created = reader.int64().toBigInt();
                    break;
                case /* string object_id */ 5:
                    message.objectId = reader.string();
                    break;
                case /* string object_type */ 6:
                    message.objectType = reader.string();
                    break;
                case /* string data_json */ 7:
                    message.dataJson = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string type = 2; */
        if (message.type !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.type);
        /* string api_version = 3; */
        if (message.apiVersion !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.apiVersion);
        /* int64 created = 4; */
        if (message.created !== 0n)
            writer.tag(4, WireType.Varint).int64(message.created);
        /* string object_id = 5; */
        if (message.objectId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.objectId);
        /* string object_type = 6; */
        if (message.objectType !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.objectType);
        /* string data_json = 7; */
        if (message.dataJson !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.dataJson);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message StripeEvent
 */
export const StripeEvent = new StripeEvent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateCustomerRequest$Type extends MessageType {
    constructor() {
        super("CreateCustomerRequest", [
            { no: 1, name: "email", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "metadata", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ } },
            { no: 5, name: "user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.email = "";
        message.name = "";
        message.description = "";
        message.metadata = {};
        message.userId = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string email */ 1:
                    message.email = reader.string();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* string description */ 3:
                    message.description = reader.string();
                    break;
                case /* map<string, string> metadata */ 4:
                    this.binaryReadMap4(message.metadata, reader, options);
                    break;
                case /* int32 user_id */ 5:
                    message.userId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    binaryReadMap4(map, reader, options) {
        let len = reader.uint32(), end = reader.pos + len, key, val;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for CreateCustomerRequest.metadata");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message, writer, options) {
        /* string email = 1; */
        if (message.email !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.email);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* string description = 3; */
        if (message.description !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.description);
        /* map<string, string> metadata = 4; */
        for (let k of globalThis.Object.keys(message.metadata))
            writer.tag(4, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.metadata[k]).join();
        /* int32 user_id = 5; */
        if (message.userId !== 0)
            writer.tag(5, WireType.Varint).int32(message.userId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CreateCustomerRequest
 */
export const CreateCustomerRequest = new CreateCustomerRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetCustomerRequest$Type extends MessageType {
    constructor() {
        super("GetCustomerRequest", [
            { no: 1, name: "customer_id", kind: "scalar", oneof: "identifier", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "user_id", kind: "scalar", oneof: "identifier", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.identifier = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string customer_id */ 1:
                    message.identifier = {
                        oneofKind: "customerId",
                        customerId: reader.string()
                    };
                    break;
                case /* int32 user_id */ 2:
                    message.identifier = {
                        oneofKind: "userId",
                        userId: reader.int32()
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string customer_id = 1; */
        if (message.identifier.oneofKind === "customerId")
            writer.tag(1, WireType.LengthDelimited).string(message.identifier.customerId);
        /* int32 user_id = 2; */
        if (message.identifier.oneofKind === "userId")
            writer.tag(2, WireType.Varint).int32(message.identifier.userId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetCustomerRequest
 */
export const GetCustomerRequest = new GetCustomerRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListCustomersRequest$Type extends MessageType {
    constructor() {
        super("ListCustomersRequest", [
            { no: 1, name: "limit", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "starting_after", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "ending_before", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "after_time", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.limit = 0;
        message.startingAfter = "";
        message.endingBefore = "";
        message.afterTime = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 limit */ 1:
                    message.limit = reader.int32();
                    break;
                case /* string starting_after */ 2:
                    message.startingAfter = reader.string();
                    break;
                case /* string ending_before */ 3:
                    message.endingBefore = reader.string();
                    break;
                case /* int64 after_time */ 4:
                    message.afterTime = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 limit = 1; */
        if (message.limit !== 0)
            writer.tag(1, WireType.Varint).int32(message.limit);
        /* string starting_after = 2; */
        if (message.startingAfter !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.startingAfter);
        /* string ending_before = 3; */
        if (message.endingBefore !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.endingBefore);
        /* int64 after_time = 4; */
        if (message.afterTime !== 0n)
            writer.tag(4, WireType.Varint).int64(message.afterTime);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ListCustomersRequest
 */
export const ListCustomersRequest = new ListCustomersRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListCustomersResponse$Type extends MessageType {
    constructor() {
        super("ListCustomersResponse", [
            { no: 1, name: "customers", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => StripeCustomer },
            { no: 2, name: "has_more", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.customers = [];
        message.hasMore = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated StripeCustomer customers */ 1:
                    message.customers.push(StripeCustomer.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* bool has_more */ 2:
                    message.hasMore = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated StripeCustomer customers = 1; */
        for (let i = 0; i < message.customers.length; i++)
            StripeCustomer.internalBinaryWrite(message.customers[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* bool has_more = 2; */
        if (message.hasMore !== false)
            writer.tag(2, WireType.Varint).bool(message.hasMore);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ListCustomersResponse
 */
export const ListCustomersResponse = new ListCustomersResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateSubscriptionRequest$Type extends MessageType {
    constructor() {
        super("CreateSubscriptionRequest", [
            { no: 1, name: "customer_id", kind: "scalar", oneof: "customerIdentifier", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "user_id", kind: "scalar", oneof: "customerIdentifier", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "price_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "quantity", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "metadata", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ } },
            { no: 6, name: "payment_method_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "default_payment_method", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.customerIdentifier = { oneofKind: undefined };
        message.priceId = "";
        message.quantity = 0;
        message.metadata = {};
        message.paymentMethodId = "";
        message.defaultPaymentMethod = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string customer_id */ 1:
                    message.customerIdentifier = {
                        oneofKind: "customerId",
                        customerId: reader.string()
                    };
                    break;
                case /* int32 user_id */ 2:
                    message.customerIdentifier = {
                        oneofKind: "userId",
                        userId: reader.int32()
                    };
                    break;
                case /* string price_id */ 3:
                    message.priceId = reader.string();
                    break;
                case /* int32 quantity */ 4:
                    message.quantity = reader.int32();
                    break;
                case /* map<string, string> metadata */ 5:
                    this.binaryReadMap5(message.metadata, reader, options);
                    break;
                case /* string payment_method_id */ 6:
                    message.paymentMethodId = reader.string();
                    break;
                case /* bool default_payment_method */ 7:
                    message.defaultPaymentMethod = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    binaryReadMap5(map, reader, options) {
        let len = reader.uint32(), end = reader.pos + len, key, val;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for CreateSubscriptionRequest.metadata");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message, writer, options) {
        /* string customer_id = 1; */
        if (message.customerIdentifier.oneofKind === "customerId")
            writer.tag(1, WireType.LengthDelimited).string(message.customerIdentifier.customerId);
        /* int32 user_id = 2; */
        if (message.customerIdentifier.oneofKind === "userId")
            writer.tag(2, WireType.Varint).int32(message.customerIdentifier.userId);
        /* string price_id = 3; */
        if (message.priceId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.priceId);
        /* int32 quantity = 4; */
        if (message.quantity !== 0)
            writer.tag(4, WireType.Varint).int32(message.quantity);
        /* map<string, string> metadata = 5; */
        for (let k of globalThis.Object.keys(message.metadata))
            writer.tag(5, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.metadata[k]).join();
        /* string payment_method_id = 6; */
        if (message.paymentMethodId !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.paymentMethodId);
        /* bool default_payment_method = 7; */
        if (message.defaultPaymentMethod !== false)
            writer.tag(7, WireType.Varint).bool(message.defaultPaymentMethod);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CreateSubscriptionRequest
 */
export const CreateSubscriptionRequest = new CreateSubscriptionRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateSubscriptionRequest$Type extends MessageType {
    constructor() {
        super("UpdateSubscriptionRequest", [
            { no: 1, name: "subscription_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "price_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "quantity", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "metadata", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ } },
            { no: 5, name: "cancel_at_period_end", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.subscriptionId = "";
        message.priceId = "";
        message.quantity = 0;
        message.metadata = {};
        message.cancelAtPeriodEnd = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string subscription_id */ 1:
                    message.subscriptionId = reader.string();
                    break;
                case /* string price_id */ 2:
                    message.priceId = reader.string();
                    break;
                case /* int32 quantity */ 3:
                    message.quantity = reader.int32();
                    break;
                case /* map<string, string> metadata */ 4:
                    this.binaryReadMap4(message.metadata, reader, options);
                    break;
                case /* bool cancel_at_period_end */ 5:
                    message.cancelAtPeriodEnd = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    binaryReadMap4(map, reader, options) {
        let len = reader.uint32(), end = reader.pos + len, key, val;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for UpdateSubscriptionRequest.metadata");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message, writer, options) {
        /* string subscription_id = 1; */
        if (message.subscriptionId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.subscriptionId);
        /* string price_id = 2; */
        if (message.priceId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.priceId);
        /* int32 quantity = 3; */
        if (message.quantity !== 0)
            writer.tag(3, WireType.Varint).int32(message.quantity);
        /* map<string, string> metadata = 4; */
        for (let k of globalThis.Object.keys(message.metadata))
            writer.tag(4, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.metadata[k]).join();
        /* bool cancel_at_period_end = 5; */
        if (message.cancelAtPeriodEnd !== false)
            writer.tag(5, WireType.Varint).bool(message.cancelAtPeriodEnd);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateSubscriptionRequest
 */
export const UpdateSubscriptionRequest = new UpdateSubscriptionRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CancelSubscriptionRequest$Type extends MessageType {
    constructor() {
        super("CancelSubscriptionRequest", [
            { no: 1, name: "subscription_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "invoice_now", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "prorate", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.subscriptionId = "";
        message.invoiceNow = false;
        message.prorate = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string subscription_id */ 1:
                    message.subscriptionId = reader.string();
                    break;
                case /* bool invoice_now */ 2:
                    message.invoiceNow = reader.bool();
                    break;
                case /* bool prorate */ 3:
                    message.prorate = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string subscription_id = 1; */
        if (message.subscriptionId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.subscriptionId);
        /* bool invoice_now = 2; */
        if (message.invoiceNow !== false)
            writer.tag(2, WireType.Varint).bool(message.invoiceNow);
        /* bool prorate = 3; */
        if (message.prorate !== false)
            writer.tag(3, WireType.Varint).bool(message.prorate);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CancelSubscriptionRequest
 */
export const CancelSubscriptionRequest = new CancelSubscriptionRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListSubscriptionsRequest$Type extends MessageType {
    constructor() {
        super("ListSubscriptionsRequest", [
            { no: 1, name: "customer_id", kind: "scalar", oneof: "identifier", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "user_id", kind: "scalar", oneof: "identifier", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "limit", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "starting_after", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "status", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.identifier = { oneofKind: undefined };
        message.limit = 0;
        message.startingAfter = "";
        message.status = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string customer_id */ 1:
                    message.identifier = {
                        oneofKind: "customerId",
                        customerId: reader.string()
                    };
                    break;
                case /* int32 user_id */ 2:
                    message.identifier = {
                        oneofKind: "userId",
                        userId: reader.int32()
                    };
                    break;
                case /* int32 limit */ 3:
                    message.limit = reader.int32();
                    break;
                case /* string starting_after */ 4:
                    message.startingAfter = reader.string();
                    break;
                case /* string status */ 5:
                    message.status = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string customer_id = 1; */
        if (message.identifier.oneofKind === "customerId")
            writer.tag(1, WireType.LengthDelimited).string(message.identifier.customerId);
        /* int32 user_id = 2; */
        if (message.identifier.oneofKind === "userId")
            writer.tag(2, WireType.Varint).int32(message.identifier.userId);
        /* int32 limit = 3; */
        if (message.limit !== 0)
            writer.tag(3, WireType.Varint).int32(message.limit);
        /* string starting_after = 4; */
        if (message.startingAfter !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.startingAfter);
        /* string status = 5; */
        if (message.status !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.status);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ListSubscriptionsRequest
 */
export const ListSubscriptionsRequest = new ListSubscriptionsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListSubscriptionsResponse$Type extends MessageType {
    constructor() {
        super("ListSubscriptionsResponse", [
            { no: 1, name: "subscriptions", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Subscription },
            { no: 2, name: "has_more", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.subscriptions = [];
        message.hasMore = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated Subscription subscriptions */ 1:
                    message.subscriptions.push(Subscription.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* bool has_more */ 2:
                    message.hasMore = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated Subscription subscriptions = 1; */
        for (let i = 0; i < message.subscriptions.length; i++)
            Subscription.internalBinaryWrite(message.subscriptions[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* bool has_more = 2; */
        if (message.hasMore !== false)
            writer.tag(2, WireType.Varint).bool(message.hasMore);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ListSubscriptionsResponse
 */
export const ListSubscriptionsResponse = new ListSubscriptionsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AttachPaymentMethodRequest$Type extends MessageType {
    constructor() {
        super("AttachPaymentMethodRequest", [
            { no: 1, name: "customer_id", kind: "scalar", oneof: "customerIdentifier", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "user_id", kind: "scalar", oneof: "customerIdentifier", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "payment_method_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "make_default", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.customerIdentifier = { oneofKind: undefined };
        message.paymentMethodId = "";
        message.makeDefault = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string customer_id */ 1:
                    message.customerIdentifier = {
                        oneofKind: "customerId",
                        customerId: reader.string()
                    };
                    break;
                case /* int32 user_id */ 2:
                    message.customerIdentifier = {
                        oneofKind: "userId",
                        userId: reader.int32()
                    };
                    break;
                case /* string payment_method_id */ 3:
                    message.paymentMethodId = reader.string();
                    break;
                case /* bool make_default */ 4:
                    message.makeDefault = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string customer_id = 1; */
        if (message.customerIdentifier.oneofKind === "customerId")
            writer.tag(1, WireType.LengthDelimited).string(message.customerIdentifier.customerId);
        /* int32 user_id = 2; */
        if (message.customerIdentifier.oneofKind === "userId")
            writer.tag(2, WireType.Varint).int32(message.customerIdentifier.userId);
        /* string payment_method_id = 3; */
        if (message.paymentMethodId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.paymentMethodId);
        /* bool make_default = 4; */
        if (message.makeDefault !== false)
            writer.tag(4, WireType.Varint).bool(message.makeDefault);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message AttachPaymentMethodRequest
 */
export const AttachPaymentMethodRequest = new AttachPaymentMethodRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DetachPaymentMethodRequest$Type extends MessageType {
    constructor() {
        super("DetachPaymentMethodRequest", [
            { no: 1, name: "payment_method_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.paymentMethodId = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string payment_method_id */ 1:
                    message.paymentMethodId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string payment_method_id = 1; */
        if (message.paymentMethodId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.paymentMethodId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message DetachPaymentMethodRequest
 */
export const DetachPaymentMethodRequest = new DetachPaymentMethodRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListPaymentMethodsRequest$Type extends MessageType {
    constructor() {
        super("ListPaymentMethodsRequest", [
            { no: 1, name: "customer_id", kind: "scalar", oneof: "customerIdentifier", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "user_id", kind: "scalar", oneof: "customerIdentifier", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "type", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.customerIdentifier = { oneofKind: undefined };
        message.type = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string customer_id */ 1:
                    message.customerIdentifier = {
                        oneofKind: "customerId",
                        customerId: reader.string()
                    };
                    break;
                case /* int32 user_id */ 2:
                    message.customerIdentifier = {
                        oneofKind: "userId",
                        userId: reader.int32()
                    };
                    break;
                case /* string type */ 3:
                    message.type = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string customer_id = 1; */
        if (message.customerIdentifier.oneofKind === "customerId")
            writer.tag(1, WireType.LengthDelimited).string(message.customerIdentifier.customerId);
        /* int32 user_id = 2; */
        if (message.customerIdentifier.oneofKind === "userId")
            writer.tag(2, WireType.Varint).int32(message.customerIdentifier.userId);
        /* string type = 3; */
        if (message.type !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.type);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ListPaymentMethodsRequest
 */
export const ListPaymentMethodsRequest = new ListPaymentMethodsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListPaymentMethodsResponse$Type extends MessageType {
    constructor() {
        super("ListPaymentMethodsResponse", [
            { no: 1, name: "payment_methods", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PaymentMethod },
            { no: 2, name: "has_more", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.paymentMethods = [];
        message.hasMore = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated PaymentMethod payment_methods */ 1:
                    message.paymentMethods.push(PaymentMethod.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* bool has_more */ 2:
                    message.hasMore = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated PaymentMethod payment_methods = 1; */
        for (let i = 0; i < message.paymentMethods.length; i++)
            PaymentMethod.internalBinaryWrite(message.paymentMethods[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* bool has_more = 2; */
        if (message.hasMore !== false)
            writer.tag(2, WireType.Varint).bool(message.hasMore);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ListPaymentMethodsResponse
 */
export const ListPaymentMethodsResponse = new ListPaymentMethodsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class HandleStripeEventRequest$Type extends MessageType {
    constructor() {
        super("HandleStripeEventRequest", [
            { no: 1, name: "event_json", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "signature", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.eventJson = "";
        message.signature = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string event_json */ 1:
                    message.eventJson = reader.string();
                    break;
                case /* string signature */ 2:
                    message.signature = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string event_json = 1; */
        if (message.eventJson !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.eventJson);
        /* string signature = 2; */
        if (message.signature !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.signature);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message HandleStripeEventRequest
 */
export const HandleStripeEventRequest = new HandleStripeEventRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StripeEventData$Type extends MessageType {
    constructor() {
        super("StripeEventData", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "stripe_event_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "event_created_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "payment_created_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "payment_intent_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "idempotency_key", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "amount", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 10, name: "currency", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "invoice_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 12, name: "kalos_customer_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 13, name: "job_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 14, name: "error_message", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 15, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 16, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 17, name: "order_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 18, name: "order_dir", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.stripeEventId = "";
        message.eventCreatedAt = "";
        message.paymentCreatedAt = "";
        message.paymentIntentId = "";
        message.idempotencyKey = "";
        message.type = "";
        message.status = "";
        message.amount = 0;
        message.currency = "";
        message.invoiceId = 0;
        message.kalosCustomerId = 0;
        message.jobNumber = "";
        message.errorMessage = "";
        message.fieldMask = [];
        message.pageNumber = 0;
        message.orderBy = "";
        message.orderDir = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* string stripe_event_id */ 2:
                    message.stripeEventId = reader.string();
                    break;
                case /* string event_created_at */ 3:
                    message.eventCreatedAt = reader.string();
                    break;
                case /* string payment_created_at */ 4:
                    message.paymentCreatedAt = reader.string();
                    break;
                case /* string payment_intent_id */ 5:
                    message.paymentIntentId = reader.string();
                    break;
                case /* string idempotency_key */ 6:
                    message.idempotencyKey = reader.string();
                    break;
                case /* string type */ 7:
                    message.type = reader.string();
                    break;
                case /* string status */ 8:
                    message.status = reader.string();
                    break;
                case /* double amount */ 9:
                    message.amount = reader.double();
                    break;
                case /* string currency */ 10:
                    message.currency = reader.string();
                    break;
                case /* int32 invoice_id */ 11:
                    message.invoiceId = reader.int32();
                    break;
                case /* int32 kalos_customer_id */ 12:
                    message.kalosCustomerId = reader.int32();
                    break;
                case /* string job_number */ 13:
                    message.jobNumber = reader.string();
                    break;
                case /* string error_message */ 14:
                    message.errorMessage = reader.string();
                    break;
                case /* repeated string field_mask */ 15:
                    message.fieldMask.push(reader.string());
                    break;
                case /* int32 page_number */ 16:
                    message.pageNumber = reader.int32();
                    break;
                case /* string order_by */ 17:
                    message.orderBy = reader.string();
                    break;
                case /* string order_dir */ 18:
                    message.orderDir = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* string stripe_event_id = 2; */
        if (message.stripeEventId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.stripeEventId);
        /* string event_created_at = 3; */
        if (message.eventCreatedAt !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.eventCreatedAt);
        /* string payment_created_at = 4; */
        if (message.paymentCreatedAt !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.paymentCreatedAt);
        /* string payment_intent_id = 5; */
        if (message.paymentIntentId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.paymentIntentId);
        /* string idempotency_key = 6; */
        if (message.idempotencyKey !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.idempotencyKey);
        /* string type = 7; */
        if (message.type !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.type);
        /* string status = 8; */
        if (message.status !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.status);
        /* double amount = 9; */
        if (message.amount !== 0)
            writer.tag(9, WireType.Bit64).double(message.amount);
        /* string currency = 10; */
        if (message.currency !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.currency);
        /* int32 invoice_id = 11; */
        if (message.invoiceId !== 0)
            writer.tag(11, WireType.Varint).int32(message.invoiceId);
        /* int32 kalos_customer_id = 12; */
        if (message.kalosCustomerId !== 0)
            writer.tag(12, WireType.Varint).int32(message.kalosCustomerId);
        /* string job_number = 13; */
        if (message.jobNumber !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.jobNumber);
        /* string error_message = 14; */
        if (message.errorMessage !== "")
            writer.tag(14, WireType.LengthDelimited).string(message.errorMessage);
        /* repeated string field_mask = 15; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(15, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* int32 page_number = 16; */
        if (message.pageNumber !== 0)
            writer.tag(16, WireType.Varint).int32(message.pageNumber);
        /* string order_by = 17; */
        if (message.orderBy !== "")
            writer.tag(17, WireType.LengthDelimited).string(message.orderBy);
        /* string order_dir = 18; */
        if (message.orderDir !== "")
            writer.tag(18, WireType.LengthDelimited).string(message.orderDir);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message StripeEventData
 */
export const StripeEventData = new StripeEventData$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StripeEventDataList$Type extends MessageType {
    constructor() {
        super("StripeEventDataList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => StripeEventData },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated StripeEventData results */ 1:
                    message.results.push(StripeEventData.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated StripeEventData results = 1; */
        for (let i = 0; i < message.results.length; i++)
            StripeEventData.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message StripeEventDataList
 */
export const StripeEventDataList = new StripeEventDataList$Type();
/**
 * @generated ServiceType for protobuf service StripeService
 */
export const StripeService = new ServiceType("StripeService", [
    { name: "CreateCustomer", options: {}, I: CreateCustomerRequest, O: StripeCustomer },
    { name: "GetCustomer", options: {}, I: GetCustomerRequest, O: StripeCustomer },
    { name: "UpdateCustomer", options: {}, I: StripeCustomer, O: StripeCustomer },
    { name: "ListCustomers", options: {}, I: ListCustomersRequest, O: ListCustomersResponse },
    { name: "AttachPaymentMethod", options: {}, I: AttachPaymentMethodRequest, O: PaymentMethod },
    { name: "DetachPaymentMethod", options: {}, I: DetachPaymentMethodRequest, O: Empty },
    { name: "ListPaymentMethods", options: {}, I: ListPaymentMethodsRequest, O: ListPaymentMethodsResponse },
    { name: "CreateSubscription", options: {}, I: CreateSubscriptionRequest, O: Subscription },
    { name: "GetSubscription", options: {}, I: String$, O: Subscription },
    { name: "UpdateSubscription", options: {}, I: UpdateSubscriptionRequest, O: Subscription },
    { name: "CancelSubscription", options: {}, I: CancelSubscriptionRequest, O: Subscription },
    { name: "ListSubscriptions", options: {}, I: ListSubscriptionsRequest, O: ListSubscriptionsResponse },
    { name: "GetInvoice", options: {}, I: String$, O: StripeInvoice },
    { name: "ListInvoices", options: {}, I: ListSubscriptionsRequest, O: ListSubscriptionsResponse },
    { name: "HandleStripeEvent", options: {}, I: HandleStripeEventRequest, O: Empty },
    { name: "CreateStripeEventData", options: {}, I: StripeEventData, O: StripeEventData },
    { name: "GetStripeEventData", options: {}, I: StripeEventData, O: StripeEventData },
    { name: "BatchGetStripeEventData", options: {}, I: StripeEventData, O: StripeEventDataList },
    { name: "UpdateStripeEventData", options: {}, I: StripeEventData, O: StripeEventData }
]);
